module.exports = __webpack_public_path__ + "media/promo/promo/images/footer-top-fa842b1a5b10b8ba9890fefec7f7c588.svg";